module.exports = __webpack_public_path__ + "static/media/1001000DO.b579bfff.jpg";